import React from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import GroupsIcon from '@mui/icons-material/Groups';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import config from '../config.json';

const valueIcons = [<RocketLaunchIcon />, <GroupsIcon />, <EmojiObjectsIcon />];

const values = config.about.values.map((item, i) => ({
  ...item,
  icon: valueIcons[i],
}));

const { about } = config;

function About() {
  const theme = useTheme();

  return (
    <Box
      id="about"
      sx={{
        py: { xs: 10, md: 14 },
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: { xs: 6, md: 8 },
            alignItems: 'center',
            mb: 8,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="overline"
              sx={{
                color: 'secondary.main',
                fontWeight: 600,
                letterSpacing: 3,
                fontSize: '0.85rem',
              }}
            >
              {about.overline}
            </Typography>
            <Typography variant="h2" sx={{ mt: 1, mb: 3 }}>
              {about.headingLine1}
              <Box
                component="span"
                sx={{
                  background: theme.custom.gradientPrimary,
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                {about.headingAccent}
              </Box>
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: 'text.secondary', mb: 2 }}
            >
              {about.description1}
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: 'text.secondary' }}
            >
              {about.description2}
            </Typography>
          </Box>

          {/* Stats / Visual */}
          {/* <Box
            sx={{
              flex: 1,
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: 3,
            }}
          >
            {[
              { number: '50K+', label: 'Active Users' },
              { number: '2M+', label: 'Cards Cataloged' },
              { number: '4.8', label: 'App Store Rating' },
              { number: '150K+', label: 'Card Sets Supported' },
            ].map((stat, index) => (
              <Box
                key={index}
                sx={{
                  textAlign: 'center',
                  p: 3,
                  borderRadius: 3,
                  background: theme.custom.statBg,
                  border: `1px solid ${theme.custom.statBorder}`,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    background: theme.custom.gradientPrimary,
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    fontWeight: 800,
                    mb: 0.5,
                  }}
                >
                  {stat.number}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: 'text.secondary', fontWeight: 500 }}
                >
                  {stat.label}
                </Typography>
              </Box>
            ))}
          </Box> */}
        </Box> 

        {/* Values */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              md: '1fr 1fr 1fr',
            },
            gap: 3,
          }}
        >
          {values.map((value, index) => (
            <Card
              key={index}
              elevation={0}
              sx={{
                textAlign: 'center',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  borderColor: 'primary.main',
                },
              }}
            >
              <CardContent sx={{ p: 4 }}>
                <Box
                  sx={{
                    color: 'primary.main',
                    mb: 2,
                    '& .MuiSvgIcon-root': {
                      fontSize: 40,
                    },
                  }}
                >
                  {value.icon}
                </Box>
                <Typography variant="h5" sx={{ mb: 1.5 }}>
                  {value.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: 'text.secondary' }}
                >
                  {value.description}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Container>
    </Box>
  );
}

export default About;
